export const LIST_FIELDS = [
     { key: 'id', label: 'ID', type: 'string', _style: { minWidth: '120px' } },
     { key: 'accountId', label: 'Account ID', type: 'string', _style: { minWidth: '120px' }, noFilter: true },
     { key: 'firstName', label: 'First Name', type: 'string', _style: { minWidth: '190px' } },
     { key: 'lastName', label: 'Last Name', type: 'string', _style: { minWidth: '155px' } },
     { key: 'currentTitle', label: 'Current Title', type: 'string', _style: { minWidth: '155px' } },
     { key: 'currentCompany', label: 'Current Company', type: 'string', _style: { minWidth: '155px' } },
     { key: 'primaryEmail', label: 'Primary Email', type: 'string', _style: { minWidth: '155px' } },
     { key: 'linkedinURL', label: 'LinkedIn URL', type: 'string', _style: { minWidth: '155px' } },
     { key: 'sourcePath', label: 'Source Path', type: 'string', _style: { minWidth: '200px' } },
     { key: 'LLMstatus', label: 'LLM Status', type: 'boolean', _style: { minWidth: '155px' } },
     { key: 'enrichType', label: 'Enrich Type', type: 'string', _style: { minWidth: '155px' } },
     { key: 'created_at', label: 'Created At', type: 'datetime', _style: { minWidth: '155px' } },
     { key: 'updated_at', label: 'Updated At', type: 'datetime', _style: { minWidth: '155px' } },
     { key: 'viewDetails', label: '', sorter: false, _style: { width: '1%' }, noFilter: true },
];

export const DEFAULT_FIELDS = [
     { key: 'viewDetails', label: '', sorter: false, _style: { width: '1%' } }
]